import {Address} from "../../../resources/common"

interface HandleSubmit {
	createFn: (params: {
		accessToken: string
		accountId: string
		customerId: string
		addressOverride?: Address
		amount?: number
		payeeName?: string
	}) => Promise<{isOk: () => boolean; isErr: () => boolean; error?: {errors: {title: string}[]}}>
	params: {
		accessToken: string
		accountId: string
		customerId: string
		addressOverride?: Address
		amount?: number
		payeeName?: string
	}
	setLoading: (loading: boolean) => void
	setSuccessMessage: (message: string) => void
	setErrorMessage: (message: string) => void
	onSuccess: () => void
	closeModal: () => void
	successMessage: string
}

export const refreshAndClose = (onSuccess: () => void, close: () => void) => {
	onSuccess()
	close()
}

export const handleSubmit = async ({
	createFn,
	params,
	setLoading,
	setSuccessMessage,
	setErrorMessage,
	onSuccess,
	closeModal,
	successMessage,
}: HandleSubmit) => {
	setLoading(true)
	const res = await createFn(params)

	if (res.isOk()) {
		setSuccessMessage(successMessage)
		setTimeout(() => {
			refreshAndClose(onSuccess, closeModal)
		}, 1500)
	} else if (res.isErr() && res.error?.errors?.length) {
		setErrorMessage(res.error.errors[0].title)
	}
	setLoading(false)
}
